<!-- filepath: d:\programming\vuejs-components\Vc Website Components\src\components\queryapp\DownloadDialog.vue -->
<template>
  <div>
    <div v-if="!embedded" class="modal-backdrop fade show" @click="close"></div>
    
    <div :class="embedded ? '' : 'modal fade show'" :style="embedded ? '' : 'display: block;'" tabindex="-1" 
         aria-labelledby="downloadModalLabel" :aria-modal="!embedded">
      <div :class="embedded ? '' : 'modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable'">
        <div :class="embedded ? '' : 'modal-content'" :style="embedded ? '' : 'min-height: 90vh; max-height: 90vh;'">
          <div v-if="!embedded" class="modal-header">
            <h5 class="modal-title" id="downloadModalLabel">
              <i class="bi bi-download text-primary"></i> {{ dialogTitle}}
            </h5>
            <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
          </div>
          
          <div class="d-flex flex-column previewTarget" :class="embedded ? '' : 'modal-body'"
               :style="embedded ? 'min-height: 600px;' : 'height: calc(800px - 120px); overflow: hidden;'">
             
                <div v-if="!hasSession">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Please sign in or create an account</h4>
                        <p>
                            Downloading weather data requires an account. 
                            Please <a href="#" class="text-primary" @click.prevent="$emit('open-sign-in')">sign in</a> or <a href="#" class="text-primary" @click.prevent="$emit('open-sign-up')">sign up</a> to proceed.
                        </p>
                    </div>
                </div>
                <div v-else-if="statsMode && !allowStatistics">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Statistics are not enabled</h4>
                        <p>
                        Weather Statistics are only available to monthly or annual plan users during beta testing. 
                        Free and Metered accounts do not have access. Please <a href="/weather-data-editions/" target="_blank" class="text-primary text-decoration-underline">upgrade</a> to use this feature.
                        </p>
                    </div>
                </div>
                <div v-else-if="scheduleMode && !allowSubscription">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Dataset Schedules are not enabled</h4>
                        <p>
                        Dataset Scheduling is not available in your plan.Please <a href="/weather-data-editions/" target="_blank" class="text-primary text-decoration-underline">upgrade</a> to use this feature.
                        </p>
                    </div>
                </div>



            <template v-if="downloadStep === 0">
             
                    <!--<h6 class="h6 mb-1">Choose the data format and sections to download</h6>-->
                    <!--<p>Download the weather data for your selected location(s) and date range in your preferred
                          format.</p>-->

                                            <div v-if="statsMode" class="d-flex flex-column flex-fill">
                        <WeatherStatisticsEditor :packageDefn="packageDefn" :sessionId="sessionId"
                        :sessionState="sessionState" :value="{ goal: 'timeline' }"
                        @update:statsdefinition="(statsDefn) => updateStatsDefinition(statsDefn, localPackageDraft)">
                        </WeatherStatisticsEditor>

                    </div>

                    <div  v-if="!statsMode"  class="d-flex flex-md-row flex-wrap justify-content-between mb-3">
                      <!-- Format Selection -->
                      <div class="mb-3 mb-md-0">
                        <div><label class="form-label fw-semibold">Data Format:</label></div>
                        <div class="btn-group btn-group-sm" role="group" aria-label="Content type selection">
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'json' }"
                            @click="setContentType(downloadQueryDraft, 'json')">
                            <i class="bi bi-braces"></i> JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'flatjson' }"
                            @click="setContentType(downloadQueryDraft, 'flatjson')">
                            <i class="bi bi-code-square"></i> Flat JSON
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'csv' }"
                            @click="setContentType(downloadQueryDraft, 'csv')">
                            <i class="bi bi-file-earmark-spreadsheet"></i> CSV
                          </button>
                          <button type="button" class="btn btn-outline-primary text-nowrap"
                            :class="{ active: downloadQueryDraft.contentType === 'xlsx' }"
                            @click="setContentType(downloadQueryDraft, 'xlsx')">
                            <i class="bi bi-file-earmark-excel"></i> Excel
                          </button>
                        </div>
                        <div  class="fs-xs form-text mt-1">
                          <span v-if="downloadQueryDraft.contentType === 'json'">
                            <strong>JSON:</strong> Hierarchical format with nested hours/days data
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'flatjson'">
                            <strong>Flat JSON:</strong> Flattened single-level JSON structure
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'csv'">
                            <strong>CSV:</strong> Comma-separated values for spreadsheet applications
                          </span>
                          <span v-else-if="downloadQueryDraft.contentType === 'xlsx'">
                            <strong>Excel:</strong> Native Excel format with multiple worksheets
                          </span>
                        </div>
                      </div>

                      <!-- Data Sections Selection -->
                      <div class="">
                        <div><label class="form-label fw-semibold">Data Sections:</label></div>
                        <div class="btn-group btn-group-sm d-flex flex-nowrap" role="group"
                          aria-label="Data sections selection">
                          <button v-for="section in dataSections" :key="section.id" type="button"
                            class="btn btn-outline-primary text-nowrap" :class="{
                              active: isSectionSelectedIn(downloadQueryDraft, section.id),
                            }" @click="toggleSectionIn(downloadQueryDraft, section.id)">
                            <i :class="section.icon"></i> {{ section.label }}
                          </button>
                        </div>
                        <div v-if="isSingleSectionOnlyFor(downloadQueryDraft)" class="fs-xs form-text mt-1">
                          <i class="bi bi-info-circle"></i>
                          {{ downloadQueryDraft.contentType.toUpperCase() }} format supports only one section
                          at a time
                        </div>
                      </div>
                    </div>
                    <!-- Cost Estimate and Sign-in Prompt -->
                    <div class="mb-4 bg-light border rounded px-2 py-3">
                      <div>

                        <div class="d-flex flex-row align-items-center justify-content-between my-2">
                         
                          <div>
                            <strong>Estimated total cost: {{ queryMeteredCostDetails }}. </strong>
                          </div>
                          
                          <div class="form-text">
                            <a href="/resources/documentation/weather-data/what-exactly-is-a-weather-record/"
                              target="_blank">What
                              exactly is a weather record?</a>
                           </div>
                        </div>

                        <div class="fs-xs form-text ">Each location costs {{ estimateQueryCost }}. Total location
                          count: {{ locationCount }}.
                          <!--
                          <a href="#" @click.prevent="showCostBreakdown = !showCostBreakdown">
                            {{ showCostBreakdown ? 'Hide' : 'Show' }} details
                            </a>
                            -->
                        </div>
                      </div>

                      <div v-if="!hasSession" class="mt-3">
                        <div class="form-text">Prices for this download will range start at {{ queryMeteredCostDetailsMetered }} for our metered plan.
                          Our monthly and annual plans allow for even more affordable query cost. </div>
                      </div>

                      <div v-else-if="isMetered" class="mt-3">
                        Used record cost: {{ currentDailyCost }}.
                        Free record count remaining: {{ remainingFreeDailyCost }}
                      </div>

                      <div v-else class="d-flex flex-wrap gap-3 mt-3 align-items-center">
                        <div class="d-flex align-items-center gap-2">
                          <small class="text-muted">Today:</small>
                          <div class="progress position-relative" style="width: 120px; height: 20px;">
                            <div class="progress-bar" role="progressbar"
                              :style="{ width: Math.max(dailyUsagePercent, 2) + '%' }" :class="dailyUsageClass">
                              <!-- Show inside if there's room -->
                              <small v-if="dailyUsagePercent > 20" class="fw-bold">
                                {{ formatCompactNumber(currentDailyCost) }}
                              </small>
                            </div>
                            <!-- Show outside if bar is too small -->
                            <div v-if="dailyUsagePercent <= 20" class="position-absolute w-100 text-center"
                              style="line-height: 20px;">
                              <small class="fw-bold text-dark">{{ formatCompactNumber(currentDailyCost) }}</small>
                            </div>
                          </div>
                          <small class="text-muted">/ {{ formatCompactNumber(dailyCostLimit) }}</small>
                        </div>

                        <div v-if="currentMonthlyCost>0" class="d-flex align-items-center gap-2">
                          <small class="text-muted">Period:</small>
                          <div class="progress position-relative" style="width: 120px; height: 20px;">
                            <div class="progress-bar" role="progressbar"
                              :style="{ width: Math.max(monthlyUsagePercent, 2) + '%' }" :class="monthlyUsageClass">
                              <!-- Show inside if there's room -->
                              <small v-if="monthlyUsagePercent > 20" class="fw-bold">
                                {{ formatCompactNumber(currentMonthlyCost) }}
                              </small>
                            </div>
                            <!-- Show outside if bar is too small -->
                            <div v-if="monthlyUsagePercent <= 20" class="position-absolute w-100 text-center"
                              style="line-height: 20px;">
                              <small class="fw-bold text-dark">{{ formatCompactNumber(currentMonthlyCost) }}</small>
                            </div>
                          </div>
                          <small class="text-muted">/ {{ formatCompactNumber(monthlyCostLimit) }}</small>
                        </div>
                      </div>

                      <div v-if="exceedsLimit" class="alert alert-danger mt-3" role="alert" v-html="exceedsLimitMsg"> </div>
                      <div v-else-if="exceedsQueryLimitMsg" class="alert alert-danger mt-3" role="alert" v-html="exceedsQueryLimitMsg"> </div>
                      <div v-else-if="isExtendedDataset" class="alert alert-warning  mt-3" role="alert">
                        This is a extended dataset and may take multiple days to run. This query cannot be
                        scheduled or downloaded via the Datasets API.
                        Please track your query progress in <a href="#" class="text-primary text-decoration-underline"
                          @click="openMyDatasetsDialog()">My
                          Datasets</a>
                        where you can download the results when they are finished.
                      </div>

                      <div v-else-if="largeDataset" class="alert alert-warning  mt-3" role="alert">
                        This is a large dataset and may take multiple hours to run. Please track your query progress
                        in <a href="#" class="text-primary text-decoration-underline" @click="openMyDatasetsDialog()">My
                          Datasets</a> where you can download the results when they are finished.
                      </div>


                     




                    </div>





                    <DownloadPreviewer v-if="supportsPreview" :sessionState="sessionState" :queryDefinition="downloadQueryDraft"
                      :location="selectedLocation" :costSaverMode="true" :maximize-target="'.previewTarget'"
                      class="flex-fill mb-3"></DownloadPreviewer>
                   


                    <!-- Navigation -->
                    <div class="d-flex justify-content-between mt-auto">
                        <div v-if="downloadStepErrorMessage" class="text-danger" role="alert">
                            <i class="bi bi-exclamation-diamond"></i> {{ downloadStepErrorMessage }}
                        </div>
                        <div class="ms-auto">
                            <button v-if="!scheduleMode && localMetadata?.id" type="button" class="btn btn-primary" 
                                    @click="runPackageNow(localPackageDraft)"
                                    :disabled="!isPackageValid(localPackageDraft) || isSaving || showConfirmOverwrite">
                                    <span v-if="isSaving"
                                    class="spinner-border spinner-border-sm me-2" role="status"></span>
                                    <i v-else class="bi bi-save me-1"  ></i>
                                    Download
                            </button>

                            <div v-else-if="statsMode" class="d-flex align-items-end justify-content-end mt-auto gap-2">
                                <button type="button" class="ms-auto btn btn-primary"
                                    :disabled="downloadStepErrorMessage || !hasValidWeatherStatsDefn(localPackageDraft)"
                                    @click="downloadStep = 1">
                                    Continue <i class="bi bi-chevron-right"></i>
                                </button>
                            </div>

                            <button v-else type="button" class="btn btn-primary" :disabled="downloadStepErrorMessage"
                                @click="downloadStep = 1">
                                Continue <i class="bi bi-chevron-right"></i>
                            </button>


                        </div>

                    </div>


                  </template>
            
            <div v-if="downloadStep === 1" class="d-flex flex-column flex-fill">
                    <template v-if="!hasSession">
                        <div class="alert alert-info" role="alert">
                            <i class="bi bi-info-circle"></i>
                            Please <a href="#" class="text-primary" @click.prevent="$emit('open-sign-in')">sign in</a> or <a href="#" class="text-primary" @click.prevent="$emit('open-sign-up')">sign up</a> to save and download your dataset.
                            </div>
                    </template>

                    <template v-if="notStarted">
                       
     


                     
                        <template v-if="!localMetadata?.id">
                         
                            <h6 class="h6 mb-3">Create a New Download Dataset</h6>
                        
                            <div class="card mb-2">
                                 <div class="card-header bg-primary ">
                                    <h6 class="mb-0 text-light">Enter a dataset name</h6>
                                </div>
                                <div class="card-body">
                                    <div style="max-width: 600px;">
                                    <!--<label for="package-name" class="form-label text-dark"><strong>Enter a dataset name</strong></label>-->
                                    <div class="input-group">
                                        <input class="form-control" type="text" id="package-name" v-model="localMetadata.name"
                                        :placeholder="defaultPackageName(localPackageDraft)" ref="nameInput"
                                        >
                                        
                                    </div>
                                    <div class="form-text">
                                        This name can be used to retrieve the saved dataset later.
                                    </div>
                                    <!--
                                    <div class="form-text">
                                        This name will appear in <a href="#" class="text-primary"
                                        @click="openMyDatasetsDialog()">My
                                        Datasets</a> and be used for file names.
                                    </div> 
                                    -->
                                    </div>  
                                </div>
                            </div>
                        </template>

                      <template v-if="bulkAllowSubscription && scheduleMode">
                        <div class="card mb-4 shadow-sm">
                          <div class="card-header bg-primary ">
                            <h6 class="mb-0 text-light"><i class="bi bi-clock me-2"></i>Scheduled Dataset</h6>
                          </div>
                          <div class="card-body">
                            <label class="form-label">Run Times (UTC)</label>
                            <div v-for="(time, idx) in (localPackageDraft.runTimes || [])" :key="idx"
                              class="input-group mb-2" style="max-width: 260px;">
                              <select class="form-select" :value="getHour(time)"
                                @change="setRunTimeHour(localPackageDraft, idx, $event.target.value)">
                                <option v-for="hour in 24" :key="hour" :value="hour - 1">
                                  {{ String(hour - 1).padStart(2, '0') }}
                                </option>
                              </select>
                              <span class="input-group-text">:</span>
                              <select class="form-select" :value="getMinute(time)"
                                @change="setRunTimeMinute(localPackageDraft, idx, $event.target.value)">
                                <option v-for="min in [0, 15, 30, 45]" :key="min" :value="min">
                                  {{ String(min).padStart(2, '0') }}
                                </option>
                              </select>
                              <button type="button" class="btn btn-outline-danger"
                                @click="removeRunTime(localPackageDraft, idx)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </div>
                            <div v-if="!localPackageDraft.runTimes || localPackageDraft.runTimes.length === 0">
                              <p>No scheduled times</p>
                            </div>
                            <button type="button" class="btn btn-outline-primary btn-sm mb-3"
                              @click="addRunTime(localPackageDraft)" :disabled="(localPackageDraft.runTimes?.length || 0) >= 1">
                              <i class="bi bi-plus-circle"></i> Add Time
                            </button>
                            <div class="form-check mb-2">
                              <input v-model="localPackageDraft.enabled" class="form-check-input" type="checkbox"
                                id="enabled">
                              <label class="form-check-label" for="enabled">Enabled</label>
                            </div>
                            <div class="form-check mb-2">
                              <input v-model="localPackageDraft.runOnce" class="form-check-input" type="checkbox"
                                id="runOnce">
                              <label class="form-check-label" for="runOnce">Run immediately</label>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--

                        -->
                    </template>

                    <div>
                      <div v-if="savePackageErrorMessage" class="alert alert-danger mt-3" role="alert">
                        {{ savePackageErrorMessage }}
                      </div>
                    </div>
                    <div>
                      <div v-if="invalidPackageMessage(localPackageDraft)" class="alert alert-warning mt-3"
                        role="alert">
                        {{ invalidPackageMessage(localPackageDraft) }}
                      </div>
                    </div>

                    <div v-if="pollingState.isRefreshingResults">
                      <div class="d-flex align-items-center">
                        <div class="spinner-border mx-2 me-3" role="status" aria-hidden="true"></div>
                        <strong>{{ processingStatusText }}</strong>

                      </div>
                      <div v-if="didYouKnowTip" class="mt-4">
                        <strong>Did you know? </strong>
                        {{ didYouKnowTip.label }}
                        <a href="#" class="text-primary" @click.prevent.stop="openDidYouKnow(didYouKnowTip)">
                          Learn more
                        </a>
                      </div>
                    </div>
                    <div v-else-if="hasResultError">
                      <strong>Error: {{ taskInstance.info || 'An unknown error occurred while processing your dataset. Please check My datasets for more information.' }}</strong>
                    </div>

                    <div v-else-if="taskInstance" class="mt-3">
                      <!-- Results Card -->
                      <div class="card">
                        <div class="card-header bg-light d-flex justify-content-between align-items-center">
                          <template v-if="hasResult">
                            <h6 class="mb-0">
                              <i class="bi bi-check-circle-fill text-success me-2"></i>
                              {{localMetadata?.name || 'Dataset'}} Complete
                            </h6>
                            <span class="badge bg-success">Ready</span>
                          </template>
                          <template v-if="hasExpired">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-warning me-2"></i>
                              Last result expired
                            </h6>
                            <span class="badge bg-warning">Expired</span>
                          </template>
                          <template v-if="hasResultError">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-danger me-2"></i>
                              Last result error
                            </h6>
                            <span class="badge bg-danger">Error</span>
                          </template>
                          <template v-if="isProcessing">
                            <h6 class="mb-0">
                              <i class="bi bi-x-circle-fill text-info me-2"></i>
                              Result is processing
                            </h6>
                            <span class="badge bg-info">Processing</span>
                          </template>
                        </div>

                        <div class="card-body">
                          <!-- Results Summary Grid -->
                          <div class="row g-1 mb-4">
                            <div class="col-md-6">
                              <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                                <span class="text-muted">Completed Locations:</span>
                                <strong>{{ taskInstance.completed }} / {{ taskInstance.total }}</strong>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                                <span class="text-muted">Format:</span>
                                <strong>{{ taskInstance.contentType?.toUpperCase() || 'N/A' }}</strong>
                              </div>
                            </div>

                            <div v-if="taskInstance.info" class="col-12">
                              <div class="p-2 bg-light rounded">
                                <span class="text-muted d-block mb-1">Additional Info:</span>
                                <small>{{ taskInstance.info }}</small>
                              </div>
                            </div>
                          </div>

                          <!-- Timestamps -->
                          <div class="row g-3 mb-4">
                            <div class="col-md-6">
                              <small class="text-muted d-block">Completed At</small>
                              <div class="fw-semibold">
                                <i class="bi bi-calendar-check me-1"></i>
                                {{ formatDateTime(taskInstance.endDatetime) }}
                              </div>
                            </div>

                            <div class="col-md-6">
                              <small class="text-muted d-block">Expires</small>
                              <div class="fw-semibold">
                                <i class="bi bi-hourglass-split me-1"></i>
                                {{ formatDateTime(taskInstance.expirationDateTime) }}
                              </div>
                            </div>
                          </div>
                          <template v-if="hasResult">
                            <!-- Download Actions -->
                            <div class="d-flex gap-2 mb-4">
                              <button type="button" class="btn btn-primary" @click="downloadResult(localMetadata)">
                                <i class="bi bi-download me-2"></i>
                                Download File
                              </button>
                            </div>

                            <!-- Direct Links Section (if metadata exists) -->
                            <div v-if="localMetadata && localMetadata.id" class="border-top pt-3">
                              <h6 class="text-muted mb-3">
                                <i class="bi bi-link-45deg me-1"></i>
                                Direct Links to Your Dataset
                              </h6>

                              <div class="d-flex flex-wrap gap-2 mb-3">
                                <button v-if="!requiresZipResult(localPackageDraft)" type="button"
                                  class="btn btn-outline-dark btn-sm" @click="copyLink(textResultsUri, $event)">
                                  <i class="bi bi-clipboard me-1"></i>
                                  {{ taskInstance.contentType?.toUpperCase() || 'Data' }} Link
                                </button>

                                <button type="button" class="btn btn-outline-dark btn-sm"
                                  @click="copyLink(zipResultsUri, $event)">
                                  <i class="bi bi-file-earmark-zip me-1"></i>
                                  ZIP Archive Link
                                </button>
                              </div>

                              <div class="alert alert-info alert-sm">
                                <i class="bi bi-info-circle me-1"></i>
                                <small>Use these links to import data directly into databases, Excel, Google Sheets,
                                  or other tools.</small>
                              </div>
                            </div>
                          </template>

                        </div>
                      </div>
                    </div>


                    <!-- Navigation -->
                    <div class="mt-auto d-flex flex-column">
                      <div v-if="showConfirmOverwrite" class="alert alert-warning mt-3" role="alert">
                        A package with the name "<strong>{{ currentName(localMetadata, packageDefn) }}</strong>" already
                        exists. Do you want to
                        overwrite it?
                        <div class="mt-2">
                          <button type="button" class="btn btn-sm btn-primary me-2"
                            @click="confirmOverwrite">Yes, Overwrite</button>
                          <button type="button" class="btn btn-sm btn-secondary"
                            @click="cancelOverwrite">Cancel</button>
                        </div>
                      </div>


                      <div class="d-flex align-items-end justify-content-end  gap-2">



                        <template v-if="notStarted" >
                          <button v-if="!scheduleMode" type="button" class="btn btn-primary" 
                                @click="runPackageNow(localPackageDraft)"
                                :disabled="!isPackageValid(localPackageDraft) || isSaving || showConfirmOverwrite">
                                <span v-if="isSaving"
                                  class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i v-else class="bi bi-save me-1"  ></i>
                                Download
                          </button>

                          <button v-if="scheduleMode" type="button" class="btn btn-primary"
                                @click="saveScheduledPackage(localPackageDraft)"
                                :disabled="!(isPackageValid(localPackageDraft)) || !localPackageDraft.runTimes?.length || isSaving || showConfirmOverwrite">
                                <span v-if="confirmationMessage">{{ confirmationMessage  }}</span>
                                <template v-else>
                                <span v-if="isSaving"
                                  class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i v-else class="bi bi-clock me-1"></i>
                                {{ !localMetadata.id ? 'Schedule' : 'Save & Schedule' }}
                                </template>
                          </button>

                          </template>
                          
                          <button v-if="hasResult && !embedded" type="button" class="btn btn-primary" @click="close">
                              Close 
                          </button>
                          



                        
                          
                 

                      </div>
                    </div>

                  </div>


            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QueryCostCalculator } from '@/visualcrossing-core/querycostcalculator';
import { VcJobStatus } from '@/visualcrossing-core/vcjobstatus';
import { VcClipboardUtils } from '@/visualcrossing-core/vcclipboardutils';
import { VcDateUtils } from '/src/visualcrossing-core/vcdateutils';
import { isValidWeatherStatisticsDefn } from '../weatherstatistics/weatherstatisticsutils.js';
import WeatherStatisticsEditor from '../WeatherStatisticsEditor.vue';
import DownloadPreviewer from "../DownloadPreviewer.vue";
import {defaultPackageName, invalidPackageMessage} from './queryapputils.js';
import { usePackageSave } from './usePackageSave.js';
export default {
  name: 'DownloadDialog',
  components: {
    WeatherStatisticsEditor,
    DownloadPreviewer
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    packageDefn: {
      type: Object,
      required: true
    },
    selectedLocation: {
      type: Object,
      default: null
    },
    sessionId: String,
    sessionState: Object,
    embedded: {
      type: Boolean,
      default: false
    },
    initialMode: {
      type: String,
      default: 'download' // 'download', 'schedule', 'stats'
    },
    metadata: {
      type: Object,
      default: () => ({ id: null, name: null, desc: null })
    },
    initialGridView: String,
    usageInfo: Object
  },
  emits: ['close', 'saved', 'download', 'update:metadata', 'open-my-datasets', 'refresh-usage', 'open-sign-in', 'open-sign-up'],
    setup() {
    // Initialize the composable
    const { isSaving, saveError, savePackage: savePackageCore } = usePackageSave();
    
    return {
      isSavingPackage: isSaving,  // Rename to avoid conflict with local state
      savePackageError: saveError,
      savePackageCore
    };
  },
  data() {
    return {
      // Local copy of package for editing
      localPackageDraft: null,
      
      // Dialog state
      downloadStep: 0,
    
      
      // Cost breakdown
      showCostBreakdown: false,
      costBreakdownMaximized: false,
      costBreakdownOriginalParent: null,
      costBreakdownOriginalNextSibling: null,
      
      // Package metadata
      localMetadata: null,
      packageName: '',
      
      // Task execution state
      taskInstance: null,
      pollingState: {
        isPolling: false,
        pollingRetries: 0,
        hasExceedRetries: false,
        isRefreshingResults: false,
        pollingTimer: null,
      },
      
      // UI state
      //isSaving: false,
      //savePackageErrorMessage: null,
      showConfirmOverwrite: false,
      confirmationMessage: null,
      overwriteResolve: null,
      existingPackageToOverwrite: null,
      // Tips
      didYouKnowTip: null,
      lastDidYouKnowRefresh: 0,
      
      // Data sections config
      dataSections: [
        { id: 'days', label: 'Days', icon: 'bi bi-calendar3', description: 'Daily data' },
        { id: 'hours', label: 'Hours', icon: 'bi bi-clock', description: 'Hourly data' },
        { id: 'minutes', label: 'Minutes', icon: 'bi bi-stopwatch', description: 'Minute data' },
        { id: 'current', label: 'Current', icon: 'bi bi-thermometer-half', description: 'Current conditions' },
        { id: 'events', label: 'Events', icon: 'bi bi-exclamation-triangle', description: 'Weather events' },
        { id: 'alerts', label: 'Alerts', icon: 'bi bi-bell', description: 'Weather alerts' }
      ],
    }
  },
  computed: {
    subscriptionParams() {
      return this.sessionState && this.sessionState.subscriptionParams;
    },
    scheduleMode() {
        return this.initialMode === 'schedule';
    },
    statsMode() {
        return this.initialMode === 'stats';
    },
    dialogTitle() {
      if (this.statsMode) {
        //return this.localMetadata?.id ? 'Edit Weather Statistics Dataset' : 'Create Weather Statistics Dataset';
        return 'Weather Statistics Dataset';
      } else if (this.scheduleMode) {
        //return this.localMetadata?.id ? 'Edit Scheduled Dataset' : 'Create Scheduled Dataset';
        return 'Scheduled Dataset';
      } else {
        return 'Download Dataset';
       // return this.localMetadata?.id ? 'Edit Dataset' : 'Download Dataset';
      }
    },
    supportsPreview() {
      return !this.statsMode;
    },
        // Bridge the composable states
    isSaving() {
      return this.isSavingPackage;
    },
    savePackageErrorMessage() {
      return this.savePackageError;
    },
    // Query definition from local package
    downloadQueryDraft() {
      return this.localPackageDraft?.params || {};
    },
    
    // Cost calculations
    detailedQueryCost() {
      return QueryCostCalculator.calculate(this.downloadQueryDraft);
    },
    
    estimateLocationCost() {
      return this.detailedQueryCost?.estimatedCost || 0;
    },
    
    estimateQueryCost() {
      return this.estimateLocationCost * this.locationCount;
    },
    locations() {
      return (this.packageDefn.locations) || null;
    },
    locationCount() {
      return (this.locations && this.locations.length) || 0;
    },
    queryMeteredCostDetails() {
      if (!this.estimateQueryCost) return "-";
      const recordText = this.estimateQueryCost === 1 ? 'record' : 'records';
      
      if (this.isMetered) {
        /*
        const price = (this.estimateQueryCost * 0.0001);
        if (price < 0.01) {
          return `${this.estimateQueryCost} ${recordText} (< $0.01)`;
        }
        return `${this.estimateQueryCost} ${recordText} ($${(this.estimateQueryCost * 0.0001).toFixed(2)})`;
        */
        return `${this.estimateQueryCost} ${recordText} ${this.queryMeteredCostDetailsMetered}`;
      } else {
        return `${this.estimateQueryCost} ${recordText}`;
      }
    },

    queryMeteredCostDetailsMetered() {
        const price = (this.estimateQueryCost * 0.0001);
        if (price < 0.01) {
          return `< $0.01`;
        }
        return `($${price.toFixed(2)})`;
    },



    // Usage limits
    currentDailyCost() {
      if (!this.usageInfo?.currentPeriodUsage) return 0;
      return this.usageInfo.currentPeriodUsage.cost;
    },
    
    currentMonthlyCost() {
      if (!this.usageInfo?.currentPeriodUsage) return 0;
      return this.usageInfo.currentPeriodUsage.periodQueryCost || 0;
    },
    
    processingStatusText() {
      if (!this.taskInstance) return "Submitting...";
      if (this.taskInstance.status === 1) return "Queued";
      if (this.taskInstance.status === 2) {
        if (this.taskInstance.completed > 1 && this.taskInstance.total > 1) {
          return `Running ${this.taskInstance.completed} of ${this.taskInstance.total}`;
        } else {
          return "Running";
        }
      }
      return null;
    },
    
    
    downloadStepErrorMessage() {
      //if (!this.hasSession) return "You must be logged in to download data.";
      return null;
    },







    dailyCostLimit() {
      return this.formatNumber(this.subscriptionParams?.maxDailyCost) || "No limit";
    },
    monthlyCostLimit() {
      return this.formatNumber(this.subscriptionParams?.maxMonthlyCost) || "No limit";
    },
    maxMonthlyCost() {
      return this.subscriptionParams?.maxMonthlyCost || 0;
    },
    dailyUsagePercent() {
      const limit = this.subscriptionParams?.maxDailyCost;
      if (!limit || limit === 0) return 0;
      const percent = (this.currentDailyCost / limit) * 100;
      return Math.min(100, Math.max(0, percent));
    },

    monthlyUsagePercent() {
      const limit = this.subscriptionParams?.maxMonthlyCost;
      if (!limit || limit === 0) return 0;
      const percent = (this.currentMonthlyCost / limit) * 100;
      return Math.min(100, Math.max(0, percent));
    },

    dailyUsageClass() {
      const percent = this.dailyUsagePercent;
      if (percent >= 90) return 'bg-danger';
      if (percent >= 75) return 'bg-warning';
      return 'bg-success';
    },

    monthlyUsageClass() {
      const percent = this.monthlyUsagePercent;
      if (percent >= 90) return 'bg-danger';
      if (percent >= 75) return 'bg-warning';
      return 'bg-success';
    },

    remainingFreeDailyCost() {
      // Get remaining free daily allowance
      const freeDailyCost = this.subscriptionParams?.freeDailyCost || 0;
      const used = this.currentDailyCost;
      return Math.max(0, freeDailyCost - used);
    },

    allowStatistics:function() {
      return this.subscriptionParams?.allowStatistics;
    },
    allowSubscription:function() {
      return this.subscriptionParams?.bulkAllowSubscriptions === 1;
    },
    bulkAllowSubscription() {
      return this.subscriptionParams?.bulkAllowSubscriptions === 1 && !this.exceedsLimit;
    },

    hasDailyLimit() {
      return this.subscriptionParams?.maxDailyCost && this.subscriptionParams.maxDailyCost > 0;
    },

    hasMonthlyLimit() {
      return this.subscriptionParams?.maxMonthlyCost && this.subscriptionParams.maxMonthlyCost > 0;
    },
    exceedsQueryLimit() {
       const estimatedCost = this.estimateLocationCost;
       const totalCost = this.estimateQueryCost;


       if (this.subscriptionParams?.bulkMaxLocations && this.subscriptionParams.bulkMaxLocations>0 && this.locationCount > this.subscriptionParams.bulkMaxLocations){
         return true;
       }
       const maxQueryCount = Math.max(this.subscriptionParams?.bulkMaxCount || 0, this.subscriptionParams?.extendedBulkMaxCount || 0);
       if (maxQueryCount > 0 && estimatedCost > maxQueryCount) {
         return true;
       }
       
       const maxQueryCost = Math.max(this.subscriptionParams?.bulkMaxCost || 0, this.subscriptionParams?.extendedBulkMaxCost || 0);
       if (maxQueryCost > 0 && totalCost > maxQueryCost) {
          return true;
      }
    },
    exceedsQueryLimitMsg() {
       const estimatedCost = this.estimateLocationCost;
       const totalCost = this.estimateQueryCost;


       if (this.subscriptionParams?.bulkMaxLocations && this.subscriptionParams.bulkMaxLocations>0 && this.locationCount > this.subscriptionParams.bulkMaxLocations){
         return "The number of locations in this query exceeds your subscription limit of " + this.subscriptionParams.bulkMaxLocations + " locations.";
       }
       const maxQueryCount = Math.max(this.subscriptionParams?.bulkMaxCount || 0, this.subscriptionParams?.extendedBulkMaxCount || 0);
       if (maxQueryCount > 0 && estimatedCost > maxQueryCount) {
         return "The estimated cost of this query exceeds your subscription limit of " + maxQueryCount + " queries.";
       }
       
       const maxQueryCost = Math.max(this.subscriptionParams?.bulkMaxCost || 0, this.subscriptionParams?.extendedBulkMaxCost || 0);
       if (maxQueryCost > 0 && totalCost > maxQueryCost) {
          return "The total cost of this query exceeds your subscription limit of " + maxQueryCost + " credits.";
      }
    },
    exceedsLimit() {
      
      
      // Check if query exceeds account limits
      if (this.isMetered) return false;


      const estimatedCost = this.estimateQueryCost;
      const maxDailyCost = this.subscriptionParams?.maxDailyCost || 0;
      const maxMonthlyCost = this.subscriptionParams?.maxMonthlyCost || 0;
      const currentDaily = this.currentDailyCost || 0;
      const currentMonthly = this.currentMonthlyCost || 0;

      return (maxDailyCost > 0 && currentDaily + estimatedCost > maxDailyCost) ||
        (maxMonthlyCost > 0 && currentMonthly + estimatedCost > maxMonthlyCost);
    },

    exceedsLimitMsg() {
      if (!this.exceedsLimit) return null;

      const estimatedCost = this.estimateQueryCost;
      const maxDailyCost = this.subscriptionParams?.maxDailyCost || 0;
      const maxMonthlyCost = this.subscriptionParams?.maxMonthlyCost || 0;
      const currentDaily = this.currentDailyCost;
      const currentMonthly = this.sessionState?.usage?.monthly?.cost || 0;

      if (maxDailyCost > 0 && currentDaily + estimatedCost > maxDailyCost) {
        return `This query will exceed your daily limit of ${maxDailyCost} records. You have used ${currentDaily} records today.`;
      }

      if (maxMonthlyCost > 0 && currentMonthly + estimatedCost > maxMonthlyCost) {
        return `This query will exceed your monthly limit of ${maxMonthlyCost} records. You have used ${currentMonthly} records this month.`;
      }

      return "";
    },

    isExtendedDataset() {
      // Check if this is an extended dataset (very large)
      //return true;
      const totalRecords = this.estimateQueryCost;
      return totalRecords > 1000000; // Adjust threshold as needed
    },

    largeDataset() {
      // Check if this is a large dataset
      const totalRecords = this.estimateQueryCost;
      return totalRecords > 100000 && !this.isExtendedDataset;
    },

 
    
    isStatsValid() {
      return this.hasValidWeatherStatsDefn(this.localPackageDraft);
    },
    
    hasSession() {
      return !!this.sessionId;
    },
    
    isMetered() {
      return this.subscriptionParams?.usageType === "metered";
    },
    
    notStarted() {
      return !(this.pollingState.isRefreshingResults || this.taskInstance);
    },
    
    isProcessing() {
      return this.pollingState.isRefreshingResults ||
        (this.taskInstance && (this.taskInstance.status === 1 || this.taskInstance.status === 2));
    },
    
    hasResult() {
      return this.taskInstance && this.taskInstance.status === 3;
    },
    
    hasResultError() {
      return this.taskInstance && this.taskInstance.status === 4;
    },
    
    hasExpired() {
      return this.taskInstance && this.taskInstance.status === 5;
    },
    
    // URLs for results
    textResultsUri() {
      return window.vcCommunicator?.constructBulkWeatherDataRequest(this.localMetadata, true, false);
    },
    
    zipResultsUri() {
      return window.vcCommunicator?.constructBulkWeatherDataRequest(this.localMetadata, true, true);
    }
  },
  
  methods: {
    updateStatsDefinition(statsDefnInfo, localPackage) {

      if (localPackage && localPackage.params) {
        localPackage.params.statsdefinition = statsDefnInfo.statsDefn;

        // Update goal if provided
        if (statsDefnInfo.goal) {
          localPackage.params.goal = statsDefnInfo.goal;
        }
        if (statsDefnInfo.include) {
          localPackage.params.include = statsDefnInfo.include;
        }
        if (statsDefnInfo.contentType) {
          localPackage.params.contentType = statsDefnInfo.contentType;
        }

      }
    },
    sortRunTimes(localPackage) {
      localPackage.runTimes.sort((a, b) => {
        const [ah, am] = a.split(':').map(Number);
        const [bh, bm] = b.split(':').map(Number);
        return ah !== bh ? ah - bh : am - bm;
      });
    },
    addRunTime(localPackage) {
      if (!localPackage.runTimes) localPackage.runTimes = [];
      let newTime = '00:00';
      if (localPackage.runTimes.length > 0) {
        // Find the latest scheduled time
        const sorted = [...localPackage.runTimes].sort((a, b) => {
          const [ah, am] = a.split(':').map(Number);
          const [bh, bm] = b.split(':').map(Number);
          return ah !== bh ? ah - bh : am - bm;
        });
        const latest = sorted[sorted.length - 1];
        let [hour, minute] = latest.split(':').map(Number);
        let nextHour = hour + 1;
        if (nextHour >= 24) {
          // If next hour is next day, repeat the latest time
          nextHour = hour;
        }
        newTime = `${String(nextHour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      }
      localPackage.runTimes.push(newTime);
      this.sortRunTimes(localPackage);
    },

    removeRunTime(localPackage, idx) {
      localPackage.runTimes.splice(idx, 1);
      this.sortRunTimes(localPackage);
    },

    setRunTimeHour(localPackage, idx, hour) {
      const minute = this.getMinute(localPackage.runTimes[idx]);
      localPackage.runTimes[idx] = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      this.sortRunTimes(localPackage);
    },

    setRunTimeMinute(localPackage, idx, minute) {
      const hour = this.getHour(localPackage.runTimes[idx]);
      localPackage.runTimes[idx] = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      this.sortRunTimes(localPackage);
    },

    updateRunTimes(localPackage, hours, minutes) {
      localPackage.runTimes = hours.map((h, i) => {
        const m = minutes[i] ?? 0;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      });
      this.sortRunTimes(localPackage);
    },
    getHour(time) {
      return parseInt(time.split(':')[0]) || 0;
    },
    getMinute(time) {
      return parseInt(time.split(':')[1]) || 0;
    },
    copyLink(request, event) {
      // Get the button element from the event
      const button = event.target.closest('button');
      if (!button) return;

      // Store the original HTML
      const originalHTML = button.innerHTML;

      // Copy to clipboard
      VcClipboardUtils.copyToClipboard(request);

      // Update button to show success
      button.innerHTML = '<i class="bi bi-check"></i> Copied!';
      button.classList.add('btn-success');
      button.classList.remove('btn-outline-primary');

      // Reset after 2 seconds
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('btn-success');
        button.classList.add('btn-outline-primary');
      }, 2000);
    },
    downloadResult(metadata, downloadAsZip) {
      if (!window.vcCommunicator) {
        console.error('vcCommunicator not available');
        return;
      }
      
      const request = window.vcCommunicator.constructBulkWeatherDataRequest(metadata, true, downloadAsZip);
      window.open(request);
    },
    requiresZipResult(localPackage) {
      var me = this;
      return me.locationCount > 1 && localPackage.params.contentType !== "csv";
    },
    currentName(metadata, localPackage) {
      

      return (metadata && metadata.name) || defaultPackageName(localPackage);
    },
    async savePackage(localPackage) {
      // Use the composable
      const result = await this.savePackageCore(
        localPackage,
        this.localMetadata,
        this.sessionState,
        {
          onConfirmOverwrite: async (existingPackage, packageName) => {
            // Show your confirmation dialog
            return new Promise((resolve) => {
              this.showConfirmOverwrite = true;
              this.existingPackageToOverwrite = existingPackage;
              this.confirmationMessage = `A package named "${packageName}" already exists. Do you want to overwrite it?`; // FIXED
              this.overwriteResolve = resolve;
            });
          }
        }
      );
      
      if (result.success) {
        // Update local metadata
        this.localMetadata = result.metadata;
        
        // Emit to parent
        this.$emit('saved', result.metadata, localPackage);
        
       
      }
      
      return result;
    },
    
    // Confirmation dialog handlers
    confirmOverwrite() {
      this.showConfirmOverwrite = false;
      if (this.overwriteResolve) {
        this.localMetadata = this.existingPackageToOverwrite;
        this.overwriteResolve(true);
        this.overwriteResolve = null;
      }
    },
    
    cancelOverwrite() {
      this.showConfirmOverwrite = false;
      if (this.overwriteResolve) {
        this.overwriteResolve(false);
        this.overwriteResolve = null;
      }
    },
    delayedRefreshPackageResults(isError) {

      const delay = isError || this.pollingState.pollingRetries > 10 ? 10000 : 5000;
      this.pollingState.isRefreshingResults = true;
      
      if (this.pollingState.pollingTimer) {
        clearTimeout(this.pollingState.pollingTimer);
      }

      this.pollingState.pollingTimer = setTimeout(() => {
        if (this._isDestroyed) return; // Add safety check
        this.pollingState.pollingTimer = null;
        this.refreshPackageResults();
      }, delay);
    },
    refreshPackageResults() {
      this.refreshDidYouKnow();
      // Polling state grouped for clarity
      if (this.pollingState.hasExceedRetries) {
        console.error("Max polling retries reached");
        this.pollingState.isRefreshingResults = false;
        return;
      }
      this.pollingState.pollingRetries++;

      // Prevent concurrent polling
      if (this.pollingState.isPolling) {
        console.log("Already polling, skipping...");
        return;
      }

      console.log(`Polling for results...${this.localMetadata.id}, refreshing = ${this.pollingState.isRefreshingResults}`);

      if (!this.localMetadata || !this.localMetadata.id) {
        console.log("No metadata for refreshPackageResults");
        return;
      }
      this.pollingState.isPolling = true;

      window.vcCommunicator.resultsByJobPackage(this.localMetadata.id)
        .then((packageResults) => {
          if (packageResults && packageResults[0] && packageResults[0].instance) {
            this.taskInstance = packageResults[0].instance;

            if (packageResults[0].runonce) {
              this.taskInstance.status = VcJobStatus.QUEUED;
            }
          } else {
            this.taskInstance = null;
          }

          // Continue refreshing only if not finished
          this.pollingState.isRefreshingResults =
            (!this.taskInstance || !VcJobStatus.isFinishedState(this.taskInstance.status));

          if (this.pollingState.isRefreshingResults) {
            this.delayedRefreshPackageResults();
          } else {
            this.hasProcessed = true;

          }
        })
        .catch((error) => {
          console.log("Failed resultsByJobPackage:", error);

          this.pollingState.isRefreshingResults =
            this.pollingState.isRefreshingResults &&
            (!this.taskInstance || !VcJobStatus.isFinishedState(this.taskInstance.status));

          if (this.pollingState.isRefreshingResults) {
            this.delayedRefreshPackageResults(true);
          }
        })
        .finally(() => {
          this.pollingState.isPolling = false;
        });
    },
    startPollForCompletion() {
      this.refreshDidYouKnow();


      this.delayedRefreshPackageResults();

    },
    refreshDidYouKnow() {
      // Refresh "Did You Know" tips
      if (!this.isSaving && !this.pollingState.isRefreshingResults) {
        this.didYouKnowTip = null;
        return;
      }
      if (this.lastDidYouKnowRefresh && (Date.now() - this.lastDidYouKnowRefresh) < 15000) {
        // Throttle to every 15 seconds
        return;
      }
      const tips = [
      
        {
          label: "You can schedule requests so that they run automatically at specified intervals. Then load the results into Excel, Google Sheets or any tool.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-schedule-weather-data-queries/"
        },

        {
          label: "You can preview your data in different formats including CSV, Excel and JSON before downloading.",
          link: "https://www.visualcrossing.com/weather-query-builder/"
        },

        {
          label: "You can select which weather elements to include in your data to keep the files small and focused on your needs.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-data/adding-and-removing-elements-from-your-weather-query/"
        },

        {
          label: "You can choose different unit systems including Metric, US, UK and others to get data in your preferred units.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-api/unit-groups-and-measurement-units/"
        },

        {
          label: "You can access weather data via our REST API for easy integration into your applications.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-api/timeline-weather-api/ "
        },

        {
          label: "You can manage your saved locations for quick access when building queries.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-data/how-to-download-weather-data-for-multiple-locations/"
        },

        {
          label: "You can get weather data for multiple locations in a single request by uploading a list of locations.",
          link: "https://www.visualcrossing.com/resources/documentation/weather-api/using-the-timeline-weather-api-with-multiple-locations-in-the-same-request/"
        },

        {
          label: "You can use our AI Assistant to help you build complex weather queries using natural language.",
          link: "https://www.visualcrossing.com/support/weather-api-ai-code-generator/"
        },

        {
          label: "We have different pricing plans to suit your needs, including a free tier for getting started.",
          link: "https://www.visualcrossing.com/weather-data-editions/"
        }

      ];

      this.didYouKnowTip = tips[Math.floor(Math.random() * tips.length)];
    },
    openDidYouKnow(tip) {
      if (!tip || !tip.link) return;

      // Open link in new window
      window.open(tip.link, '_blank', 'noopener,noreferrer');

      // Track with Google Analytics
      if (window["gtag"]) {
        gtag('event', 'did_you_know_click', {
          event_category: 'engagement',
          event_label: tip.label,
          event_value: tip.link,
          method: 'Vc'
        });
      }
    },
    async runPackageNow(localPackage) {
      localPackage.runOnce = true;
      this.downloadStep = 1;
      const result = await this.savePackage(localPackage);

      if (result.success) {
        this.startPollForCompletion();
      }
    },
    async saveScheduledPackage(localPackage) {
      //localPackage.runOnce = false;
      if (!localPackage.runTimes?.length) {
        return;
      }
      const result = await this.savePackage(localPackage);
      if (result.success) {
        if (localPackage.runOnce) {
          this.startPollForCompletion();
        } else {
          this.confirmationMessage = 'Package saved successfully.';
          setTimeout(() => {
            this.confirmationMessage = null;
            this.close();
          }, 2000);
        }


      }
    },
    isPackageValid(localPackage) {

      return !invalidPackageMessage(localPackage) && this.hasSession;
    },
    invalidPackageMessage(packageDraft) {
        return invalidPackageMessage(packageDraft);
    },
    defaultPackageName(packageDraft) {
        return defaultPackageName(packageDraft);
    },
    // Initialize dialog when opened
    initialize() {
      // Create local copy of package
      this.localPackageDraft = this.deepClone(this.packageDefn);
      this.localMetadata = { ...this.metadata };
      
      if (!this.localMetadata?.id) {
        this.localPackageDraft.params.contentType = 'csv';
        this.localPackageDraft.params.include = this.initialGridView || 'days';
      }

      if (this.localPackageDraft.params.contentType === 'csv' ||
          this.localPackageDraft.params.contentType === 'xlsx') {
        // Ensure only one section is selected
        const sections = this.selectedSectionsFrom(this.localPackageDraft);
        if (sections.length > 1) {
          const chosen = sections[0];
          this.localPackageDraft.params.include =  this.initialGridView || chosen || 'days';
        }
      }
      // Reset state
      this.taskInstance = null;

      this.showConfirmOverwrite = false;
      this.confirmationMessage = null;
      
      // Refresh usage info if needed
      this.refreshUsageInfo();
    },
    
    close() {
      // Clean up polling
      if (this.pollingState.pollingTimer) {
        clearTimeout(this.pollingState.pollingTimer);
      }
      
      this.$emit('close');
    },
    
    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    
    // Section management
    selectedSectionsFrom(qd) {
      const include = qd?.include;
      if (!include) return ['days', 'hours', 'current', 'alerts'];
      return include.split(',').map(s => s.trim()).filter(Boolean);
    },
    
    isSectionSelectedIn(qd, sectionId) {
      return this.selectedSectionsFrom(qd).includes(sectionId);
    },
    
    toggleSectionIn(qd, sectionId) {
      if (!qd) return;
      let sections = [...this.selectedSectionsFrom(qd)];
      const idx = sections.indexOf(sectionId);
      const isSingle = this.isSingleSectionOnlyFor(qd);
      
      if (isSingle) sections = [sectionId];
      else (idx > -1) ? sections.splice(idx, 1) : sections.push(sectionId);
      
      qd.include = sections.join(',');
    },
    
    isSingleSectionOnlyFor(qd) {
      const t = qd?.contentType;
      return t === 'csv' || t === 'xlsx';
    },
    
    setContentType(queryDefn, type) {
      const previousType = queryDefn.contentType;
      if (previousType === type) return;
      
      queryDefn.contentType = type;
      
      const wasSingle = previousType === 'csv' || previousType === 'xlsx';
      const isSingle = type === 'csv' || type === 'xlsx';
      
      if (!wasSingle && isSingle) {
        const sections = this.selectedSectionsFrom(queryDefn);
        let chosen = sections[0] || 'days';
        queryDefn.include = chosen;
      }
    },
    
  
    
    // Stats definition
    handleStatsDefinitionUpdate(event) {
      if (this.localPackageDraft?.params) {
        this.localPackageDraft.params.statsdefinition = event.newValue;
        if (event.goal) {
          this.localPackageDraft.params.goal = event.goal;
        }
      }
    },
    
    hasValidWeatherStatsDefn(localPackage) {
      const localQueryDefn = localPackage?.params;
      return localQueryDefn && isValidWeatherStatisticsDefn(localQueryDefn);
    },
    

    
    copyLink(url, event) {
      VcClipboardUtils.copyToClipboard(url);
      // Update button UI
      const button = event.target.closest('button');
      if (button) {
        const originalHTML = button.innerHTML;
        button.innerHTML = '<i class="bi bi-check"></i> Copied!';
        button.classList.add('btn-success');
        button.classList.remove('btn-outline-primary');
        
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.classList.remove('btn-success');
          button.classList.add('btn-outline-primary');
        }, 2000);
      }
    },
    
    refreshUsageInfo() {
      // Request parent to refresh usage info
      this.$emit('refresh-usage');
    },
    
    openMyDatasetsDialog() {
      this.$emit('open-my-datasets');
      this.close();
    },
    formatNumber(num) {
      if (num === null || num === undefined) return '-';
      return num.toLocaleString();
    },
    // Format helpers
    formatDateTime(epochSecs) {
      return VcDateUtils.formatDateTime2(epochSecs, null, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      });
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    },
    
    formatCompactNumber(num) {
      if (num === null || num === undefined) return '0';
      if (typeof num === 'string') return num;
      
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toLocaleString();
    }
  },
  
  watch: {
    show(newVal) {
      if (newVal) {
        this.initialize();
      }
    },
    metadata: {
      handler(newMeta) {
        if (this.embedded && newMeta) {
          this.localMetadata = { ...newMeta };
        }
      },
      deep: true
    },
    packageDefn: {
      handler(newDefn) {
        if (this.embedded && newDefn && !this.pollingState.isRefreshingResults && !this.taskInstance) {
          // In embedded mode, keep localPackageDraft in sync with parent
          // unless we're in the middle of executing/polling
          this.localPackageDraft = this.deepClone(newDefn);
        }
      },
      deep: true
    }
  },
  mounted() {
    // Initialize when component is mounted
    this.initialize();
  },
  beforeUnmount() {
    this._isDestroyed = true; // Set flag
    
    // Clean up all timers
    if (this.pollingState?.pollingTimer) {
      clearTimeout(this.pollingState.pollingTimer);
      this.pollingState.pollingTimer = null;
    }
    
    // Stop any ongoing polling
    this.pollingState.isRefreshingResults = false;
    this.pollingState.isPolling = false;
  }
}
</script>

<style scoped>
/* Move all download dialog specific styles here */
.cost-breakdown-container {
  transition: all 0.3s ease;
  max-height: 300px;
  overflow: auto;
}

.cost-breakdown-container.maximized {
  position: fixed !important;
  top: 60px !important;
  left: 20px !important;
  right: 20px !important;
  bottom: 20px !important;
  max-height: none !important;
  z-index: 2000 !important;
  background: white;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
}
</style>